import { useEffect, useState } from 'react';
import { AritoFormV2, AritoIcon, BottomActionBarV2, DialogV2 } from '@/components/custom/erp';
import { FormSchema, FormValues, initialFormValues } from '../../schema';
import { ThuChi, ThuChiInput } from '@/types/schemas';
import { BasicInfoTab } from './BasicInfoTab';
import { useFormState } from '../../hooks';
import { FormMode } from '@/types/form';

interface FormDialogProps {
  formMode: FormMode;
  open: boolean;
  initialData?: ThuChi;
  onSubmit?: (data: ThuChiInput) => void;
  onClose: () => void;
  onAdd?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  onCopy?: () => void;
}

const FormDialog = ({
  open,
  onClose,
  onSubmit,
  formMode,
  initialData,
  onAdd,
  onEdit,
  onDelete,
  onCopy
}: FormDialogProps) => {
  const [isFormDirty, setIsFormDirty] = useState<boolean>(false);
  const { state, actions } = useFormState(initialData);

  useEffect(() => {
    if (!open) {
      setIsFormDirty(false);
    }
  }, [open]);

  const handleSubmit = (data: FormValues) => {
    onSubmit?.({
      ...data,
      ma_cha: state.parent?.uuid
    });
    setIsFormDirty(false);
  };

  return (
    <>
      <DialogV2
        open={open}
        onClose={onClose}
        title={formMode === 'add' ? 'Mới' : formMode === 'edit' ? 'Sửa' : 'Danh mục thu chi'}
        maxWidth='xl'
        disableBackdropClose={false}
        disableEscapeKeyDown={true}
        titleIcon={<AritoIcon icon={281} />}
      >
        <AritoFormV2
          mode={formMode}
          hasAritoActionBar={false}
          schema={FormSchema}
          onSubmit={handleSubmit}
          onClose={onClose}
          initialData={(initialData || initialFormValues) as FormValues}
          className='w-[800px] overflow-y-auto'
          headerFields={
            <div onChange={() => setIsFormDirty(true)}>
              <BasicInfoTab formMode={formMode} formState={{ state, actions }} />
            </div>
          }
          bottomBar={
            <BottomActionBarV2
              mode={formMode}
              onClose={onClose}
              onAdd={onAdd}
              onEdit={onEdit}
              onDelete={onDelete}
              onCopy={onCopy}
            />
          }
        />
      </DialogV2>
    </>
  );
};

export default FormDialog;
